import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { IconButtonTransparent } from '@isyc-react/form/modules/button';
import { DropCamera } from "../../drop-camera";
import '@isyc-react/design/main';
export const DropCameraButton = props => {
  const {
    onFile,
    options,
    disabled
  } = props;
  const [show, setShow] = React.useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, (options.photo.allow || options.record.allow) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButtonTransparent, {
    disabled: disabled,
    onClick: () => setShow(true)
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-camera"
  })), /*#__PURE__*/React.createElement(DropCamera, {
    show: show,
    options: options,
    onChange: setShow,
    onFile: file => {
      onFile && onFile(file);
      setShow(false);
    }
  })));
};